const Mission = () => {
  return (
    <div>
      {/* <div className="flex flex-col justify-center  gap-4 max-w-[50rem] mx-auto  p-[2rem]"></div> */}

      <div className="flex flex-col justify-center max-w-[50rem] items-center gap-3 mx-auto text-left pb-[.5rem] px-[2rem]">
        <hr className="w-full lg:w-[50rem] mx-[auto]" />
        <h1 className="sm:text-[40px] text-[30px] font-bold pt-[.1rem] text-left w-[100%]">
          Mission Statement
        </h1>
        {/* <p className="text-center sm:w-[40rem]">
        Passionately adding greater value to our services with the help of technological advancements, to enhance productivity 
        by simplifying and enriching everyday lives of our customers.
        </p> */}
        <p className="w-full max-w-[50rem] text-justify mx-auto">
          Our most precious asset – the term ‘TCS KARDO’ has been gifted to us
          by the people of Pakistan as an expression of their affection and
          TRUST.
        </p>
        <p className="w-full max-w-[50rem] text-justify mx-auto">
          It is by delivering on this trust every single day, come rain or
          shine, over the past four decades that we have become the country’s
          logistics backbone delivering an array of services to businesses and
          consumers alike.
        </p>
        <p className="w-full max-w-[50rem] text-justify mx-auto">
          We now pledge to add greater value to our services through a blend of
          passion and new technologies aimed at enhancing productivity of our
          clients, whilst simplifying and enriching everyday lives of our
          consumers.
        </p>
        <p className="w-full max-w-[50rem] text-justify mx-auto">
          Additionally, we will extend our Air and Ground Logistics Services
          beyond borders opening new trade routes shaped by the emerging
          regional opportunities, to the benefit of Pakistan.
        </p>
        <div className=" flex flex-col justify-center  mt-[.3rem] w-[100%]">
          <h1 className="sm:text-[40px] text-[30px] font-bold text-left">
            Vision
          </h1>
          <p className=" text-left">
            To become the logistics backbone of the country.
          </p>
        </div>

        <div className=" flex flex-col justify-center  mt-[.6rem] w-[100%]">
          <h1 className="sm:text-[40px] text-[30px] text-left  font-bold">
            Core Values
          </h1>
          {/* <p className="text-left">
            Passion — to deliver quality to our customers
          </p>
          <p className="text-left">
            Advancement — of our employees and a merit-based culture
          </p>
          <p className="text-left">Fairness — for all stakeholders</p>
          <p className="text-left">Lawfulness — with respect to everything</p>
          <p className="text-left">
          </p>
          <p className="text-left">Efficiency — for better profitability</p> */}
          <p className="text-left">To love our customers and deliver quality</p>
          <p className="text-left">
            Development of our employees in a merit-based culture
          </p>
          <p className="text-left">Justice to all stakeholders</p>
          <p className="text-left">Lawful in every respect</p>
          <p className="text-left">A giving back culture</p>
          <p className="text-left">Profitability through efficiency</p>
        </div>
      </div>
    </div>
  );
};

export default Mission;
